import React from 'react';
import './Body.css';
import RouterOutlet from '../../Routes';

const Body = () => {
  return (
    <div className="app-body" id="app-body">
      <RouterOutlet />
    </div>
  );
};

export default Body;
